<template>
  <div class="pt-4 pb-24 px-4">
    <h3 class="text-3xl font-bold mb-5">{{ $t('logs') }}</h3>

    <div class="mt-3">
      <template v-if="loadingLogs">
        <div class="rounded-xl overflow-hidden mt-4" :class="[$theme.cardBg]">
          <LoadingBlock />
        </div>
      </template>
      <template v-else>
        <div class="rounded-xl overflow-hidden mt-4 border" :class="[$theme.cardBg, $theme.borderBlockColor]">
          <div
              v-for="(log, logIndex) in logs.data"
              :key="log.id"
              class="cursor-pointer"
              :class="[
              $theme.cardBorderColor,
              logIndex !== (logs.data.length - 1) ? 'border-b' : ''
            ]"
          >
            <div
                class="flex items-center justify-between px-3 py-2 hover:bg-opacity-5 transition-colors"
                :class="[$theme.cardHoverBg]"
                @click="toggleExpand(log.id)"
            >
              <div class="flex-1">
                <div class="text-xs mb-1">
                  <span class="opacity-50">{{ getDateFormat(log.created_at) }}</span>
                </div>
                <div class="text-sm font-medium" :class="[$theme.baseTextColor]">
                  {{ log.message }}
                </div>
              </div>
              <div class="flex items-center ml-2">
                <ChevronRightIcon
                    v-if="log.children?.length"
                    class="w-5 transition-transform duration-200"
                    :class="{
                    'transform rotate-90': expandedLogs.includes(log.id),
                    [$theme.baseTextColor]: true
                  }"
                />
              </div>
            </div>
            <div
                v-if="expandedLogs.includes(log.id)"
                class="my-2"
                :class="[$theme.borderBlockColor]"
            >
              <div
                  v-for="child in log.children"
                  :key="child.id"
                  class="ml-2 mb-2 pl-3 pr-1 py-1 rounded-lg mr-2 relative"
                  :class="[$theme.cardBg, $theme.borderBlockColor]"
              >
                <div
                    class="absolute left-0 top-0 h-full w-1 rounded-lg"
                    :class="[
                      child.type === 'info' && 'bg-blue-600',
                      child.type === 'alert' && 'bg-indigo-600',
                      child.type === 'warning' && 'bg-yellow-400',
                      child.type === 'error' && 'bg-red-500',
                      child.type === 'success' && 'bg-green-500',
                    ]"
                ></div>
                <div class="text-xs mb-1">
                  <span class="opacity-50">{{ getDateFormat(child.created_at) }}</span>
                </div>
                <div class="text-sm opacity-80" :class="[$theme.baseTextColor]">
                  {{ child.message }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="logs.last_page > form.page">
          <button
              @click="onLoadMore"
              class="w-full text-sm py-3 rounded-xl font-medium mt-2"
              :class="[
              loadingMore ? 'opacity-60 pointer-events-none' : '',
              $theme.outlineBtnBg,
              $theme.outlineBtnTextColor,
            ]"
          >
            <template v-if="loadingMore">
              <ButtonSpinnerBlue />
            </template>
            {{ $t('load_more') }}
          </button>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {addBackButton, hideBackButton} from "@/helpers/telegramHelper";
import LoadingBlock from "@/components/LoadingBlock.vue";
import {ChevronRightIcon} from "@heroicons/vue/24/outline";
import ButtonSpinnerBlue from "@/components/ButtonSpinnerBlue.vue";

export default {
  components: {
    ButtonSpinnerBlue,
    ChevronRightIcon,
    LoadingBlock,
  },

  methods: {
    getDateFormat(dateString) {
      const date = new Date(dateString);

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };

      return date.toLocaleString('en-GB', options).replace(',', '');
    },

    onShowDetail(detail) {
      this.detail = detail;
      this.showDetail = true;
    },

    loadLogs() {
      this.$api.get('/user/logs').then((result) => {
        this.logs = result.data;
        this.meta = result.data.meta;
        this.loadingLogs = false;
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },
    onLoadMore() {
      this.loadingMore = true;
      this.form.page += 1;

      this.$api.get('/user/logs', {
        params: this.form
      }).then((result) => {
        this.logs.data = [...this.logs.data, ...result.data.data];
        this.loadingMore = false;
      }).catch(e => {
        console.log(e);
        this.error = e;
      });
    },

    toggleExpand(logId) {
      const index = this.expandedLogs.indexOf(logId)
      if (index > -1) {
        this.expandedLogs.splice(index, 1)
      } else {
        this.expandedLogs.push(logId)
      }
    },

    formatExtraValue(value) {
      if (Array.isArray(value)) {
        return value.map(v => Array.isArray(v) ? v.join(': ') : v).join(', ')
      }
      return typeof value === 'object' ? JSON.stringify(value) : value
    },
  },

  data() {
    return {
      error: null,
      loadingLogs: true,
      loadingMore: false,
      logs: [],
      expandedLogs: [],
      form: {
        page: 1
      },

      detail: null,
      showDetail: false,
    }
  },

  mounted() {
    addBackButton(this.$router);

    this.loadLogs();
  },

  beforeUnmount() {
    hideBackButton();
  }
}
</script>
